export default __webpack_public_path__ + "static/media/zoo.f8357386.webp";